import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M9.5252 17.657L4.5752 12.707L5.9892 11.293L9.5267 14.8265L9.5252 14.828L18.0102 6.34299L19.4242 7.75699L10.9392 16.243L9.5262 17.656L9.5252 17.657Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Check"
);
